// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__sye25","alertIcon":"ConfirmModal_alertIcon__2CQ7R"};